import React from "react";
import { Box, Flex, Image, Text, Button } from "@chakra-ui/react";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import "./project.css";

const Projects = () => {
  return (
    <Box
      style={{
        width: "100%",
        // backgroundColor: "rgb(10,23,46)",
        // fontFamily: "monospace",
        fontSize: "15px",
      }}
      padding={{ md: "30px", base: "15px" }}
      id="projects"
    >
      <Text
        color="black"
        // fontWeight="200px"
        fontSize={{ md: "35px", base: "28px" }}
        textAlign="center"
        marginLeft={{ md: "20px", base: "10px" }}
      >
        <span
          style={{
            // borderBottom: "solid",,
            
            padding: "0px",
            paddingTop: "5px",
            paddingBottom: "8px",
          }}
        >
          PROJECTS
        </span>
      </Text>
      <Box margin={{ md: "25px" }} display={{ md: "block", base: "none" }}>
        {/* CruiseRental*/}
        <Flex
          alignItems={"center"}
          padding={"25px"}
          w="100%"
          margin="auto"
          marginTop={"25px"}
          className="project-card"
        >
          <Box w="60%" bg={"brown"} borderRadius={"5px"}>
            <Image
              borderRadius={"5px"}
              width={"100%"}
              src="https://64.media.tumblr.com/549bfda1dd3812cc8280a0f576050618/31abb971bc94df7d-71/s540x810/ad0fe8761045bbfcddb79c9ec80a82c56afa97f5.pnj"
            />
          </Box>
          <Box className="ProjectInformation">
            {" "}
            <Box className="project-title">Clone of AXOS</Box>
            <Box className="project-description">
            Goxos is the clone of Axos which is an e-commerce shoping website,
              which is US based,where user can buy several products like cloths of all the Genders,
              Men's ,Women's,Kids
            </Box>
            <Box className="project-tech-stack" paddingBottom={"0px"}  textAlign={"right"}>
              ReactJS | Redux | Typescript | JSON Server
            </Box>
            <Box
              className="project_tectstack"
              paddingTop={"0px"}
              paddingBottom={"0px"}
            >
              {" "}
              MongoDB | ExpressJS | NodeJS
            </Box>
            <Box className="project_tectstack" paddingTop={"0px"}>
              Chakra-UI
            </Box>
            <Flex  >
              <Box margin={"5px"} className="project-deployed-link"> 
                <a
                  href="https://gosox.vercel.app/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    fontSize={"18px"}
                    color={"white"}
                  >
                    Live&nbsp;{" "}
                    <span class="material-symbols-outlined">open_in_new</span>
                  </Button>
                </a>
              </Box>
              <Box margin={"5px"} className="project-github-link">
                <a
                  href="https://github.com/SG-Kolipyaka/concerned-toothpaste-1616/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    color="white"
                    fontSize={"18px"}
                  >
                    Github&nbsp;
                    <AiFillGithub />
                  </Button>
                </a>
              </Box>
            </Flex>
          </Box>
        </Flex>

        {/* Oasis */}
        <Flex
          alignItems={"center"}
          padding={"25px"}
          w="100%"
          margin="auto"
          marginTop={"25px"}
          className="project-card"
        >
          <Box className="ProjectInformation_2">
            {" "}
            <Box className="project-title" id="id1">Clone of FlipKart</Box>
            <Box className="project-description" id="id2">
            SmilyKart is a clone of e-commerce website called FlipKart.
              which seels all kinds of Products kile Cloths,Electronics and many more.
              where user can simply add to cart and order or Buy it.
            </Box>
            <Box className="project-tech-stack" id="project_tectstack_2" paddingBottom="0px">
              HTML | Redux | TypeScript | JSON Server
            </Box>
            <Box className="project_tectstack_2" id="project_tectstack_2" paddingTop="0px">
              ReactJS | Chakra-UI
            </Box>
            <Flex className="project_links_2">
              <Box margin={"5px"} className="project-github-link">
                <a
                  href="https://github.com/narender24681/innate-partner-2755"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <Button
                    bg={"brown"}
                    border={"brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    color={"white"}
                    fontSize={"18px"}
                  >
                    Github&nbsp;
                    <AiFillGithub />
                  </Button>
                </a>
              </Box>
              <Box margin={"5px"} className="project-deployed-link">
                <a
                  href="https://incandescent-cassata-f56374.netlify.app/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    color={"white"}
                    fontSize={"18px"}
                  >
                    Live&nbsp;
                    <span class="material-symbols-outlined">open_in_new</span>
                  </Button>
                </a>
              </Box>
            </Flex>
          </Box>
          <Box w="60%" bg={"brown"} borderRadius={"5px"}>
            <Image
              borderRadius={"5px"}
              src="https://64.media.tumblr.com/811be4ce4f64efdce915f4fe02f7003a/6750f3f04c7f986a-8c/s540x810/0215d2dc1bee77c19faa2835cc904eb39ab00b17.pnj"
              width={"100%"}
            />
          </Box>
        </Flex>

        {/* Shopetronics */}
        <Flex alignItems={"center"} padding={"25px"} w="100%" margin="auto" className="project-card">
          <Box w="60%" bg={"brown"} borderRadius={"5px"}>
            <Image
              borderRadius={"5px"}
              src="https://64.media.tumblr.com/86367c75511f752e9ceab7ff90c877ab/b715845dda01a9d0-53/s540x810/1131193ec666d6bb52375f20d4051d9a01fc4753.pnj"
              width={"100%"}
            />
          </Box>
          <Box className="ProjectInformation">
            {" "}
            <Box className="project-title">Clone of CaratLane</Box>
            <Box className="project-description">
            Infinity-Stone is a clone of e-commerce website called CaratLane.
              which sells Ornaments across the globe. This is an group
              project developed in the time span of 6 days.
            </Box>
            <Box className="project-tech-stack" paddingBottom="0px" textAlign={"right"}>
            ReactJS | Redux | Typescript
            </Box>
            <Box className="project_tectstack" paddingTop="0px">
            MongoDB | ExpressJS | NodeJS |Chakra UI
            </Box>
            <Flex >
              <Box margin={"5px"} className="project-deployed-link">
                <a
                  href="https://infinity-stone.vercel.app/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    fontSize={"18px"}
                    color={"white"}
                  >
                    {" "}
                    Live&nbsp;
                    <span class="material-symbols-outlined">open_in_new</span>
                  </Button>
                </a>
              </Box>
              <Box margin={"5px"} className="project-github-link">
                <a
                  href="https://github.com/VivekTomar03/mysterious-cause-3185"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    fontSize={"18px"}
                    color={"white"}
                  >
                    Github&nbsp;
                    <AiFillGithub />
                  </Button>
                </a>
              </Box>
            </Flex>
          </Box>
        </Flex>

        {/* BestReads */}
        <Flex
          alignItems={"center"}
          padding={"25px"}
          w="100%"
          margin="auto"
          marginTop={"25px"}
          className="project-card"
        >
          <Box className="ProjectInformation_2">
            {" "}
            <Box className="project-title" id="id1">G'K Taste</Box>
            <Box className="project-description" id="id2">
            GK Taste is an Food related website ,where Different Kind of Foods,
             are available like Veg,and Non veg with Varities.
             User can simply order the food and the food will be Delivered.
            </Box>
            <Box className="project-tech-stack">ReactJS | Redux | Typescript | Chakra UI</Box>
            <Flex className="project_links_2">
              <Box margin={"5px"} className="project-github-link">
                <a
                  href="https://github.com/SG-Kolipyaka/adroit-desire-6989"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  {" "}
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    color={"white"}
                    fontSize={"18px"}
                  >
                    Github&nbsp;
                    <AiFillGithub />
                  </Button>
                </a>
              </Box>
              <Box margin={"5px"} className="project-deployed-link">
                <a
                  href="https://gktaste.netlify.app/"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Button
                    bg={"brown"}
                    border={"solid brown"}
                    _hover={{
                      bg: "pink",
                      color:"black"
                    }}
                    color={"white"}
                    fontSize={"18px"}
                  >
                    Live&nbsp;
                    <span class="material-symbols-outlined">open_in_new</span>
                  </Button>
                </a>
              </Box>
            </Flex>
          </Box>
          <Box w="60%" bg={"brown"} borderRadius={"5px"}>
            <Image
              borderRadius={"5px"}
              src="https://64.media.tumblr.com/d82dfa492a0b14ca2abed06ca2f97911/a7cc72e8e182cc99-b7/s540x810/152d0ff559cc2f84b4f88dc8ddd9df8c7f25e897.pnj"
              width="100%"
            />
          </Box>
        </Flex>
      </Box>






      {/* Small Screen Projects */}

      <Box display={{ base: "block", md: "none", lg: "none" }} padding={"20px"} id="projects">
        {/*CruiseRental*/}
        <Box className="project-card" id="Projects_small">
          <Image
            borderRadius={"5px"}
            src="https://64.media.tumblr.com/549bfda1dd3812cc8280a0f576050618/31abb971bc94df7d-71/s540x810/ad0fe8761045bbfcddb79c9ec80a82c56afa97f5.pnj"
          />
          <Box className="project-title" id="project_title_small">Clone of AXOS</Box>
          <Box className="project-tech-stack" id="project_tectstack_small">
            ReactJS | Redux | Typescript | Chakra-UI | MongoDB | ExpressJS |
            NodeJS
          </Box>
          <Box className="project-description" id="project_description_small">
          Goxos is the clone of Axos which is an e-commerce shoping website,
              which is US based,where user can buy several products like cloths of all the Genders,
              Men's ,Women's,Kids
          </Box>
          <Flex className="project_links_small" id="project_links_small">
            <Box className="project-github-link" id="project_link_small">
              <a
                href="https://github.com/SG-Kolipyaka/concerned-toothpaste-1616"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <AiFillGithub />
              </a>
            </Box>
            <Box className="project-deployed-link" id="project_link_small">
              <a
                href="https://gosox.vercel.app/"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <span class="material-symbols-outlined">open_in_new</span>
              </a>
            </Box>
          </Flex>
        </Box>

        {/* Oasis */}
        <Box className="project-card" id="Projects_small">
          <Image
            borderRadius={"5px"}
            src="https://64.media.tumblr.com/811be4ce4f64efdce915f4fe02f7003a/6750f3f04c7f986a-8c/s540x810/0215d2dc1bee77c19faa2835cc904eb39ab00b17.pnj"
          />
          <Box className="project-title" id="project_title_small">Clone of FlipKart</Box>
          <Box className="project-tech-stack" id="project_tectstack_small">
            HTML | CSS | JavaScript | ReactJS | Chakra-UI | JSON Server
             | Redux
          </Box>
          <Box className="project-description" id="project_description_small">

          SmilyKart is a clone of e-commerce website called FlipKart.
              which seels all kinds of Products kile Cloths,Electronics and many more.
              where user can simply add to cart and order or Buy it.
          </Box>
          <Flex className="project_links_small" id="project_links_small">
            <Box className="project-github-link" id="project_link_small">
              <a
                href="https://github.com/narender24681/innate-partner-2755"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <AiFillGithub />
              </a>
            </Box>
            <Box className="project-deployed-link" id="project_link_small">
              <a
                href="https://incandescent-cassata-f56374.netlify.app/"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <span class="material-symbols-outlined">open_in_new</span>
              </a>
            </Box>
          </Flex>
        </Box>

        {/* Shopetornics */}
        <Box className="project-card" id="Projects_small" >
          <Image
            borderRadius={"5px"}
            src="https://64.media.tumblr.com/86367c75511f752e9ceab7ff90c877ab/b715845dda01a9d0-53/s540x810/1131193ec666d6bb52375f20d4051d9a01fc4753.pnj"
          />
          <Box className="project-title" id="project_title_small">Clone Of CaretLane</Box>
          <Box className="project-tech-stack" id="project_tectstack_small">
          ReactJS | Redux | Typescript | Chakra-UI | MongoDB | ExpressJS |
            NodeJS
          </Box>
          <Box className="project-description" id="project_description_small">
          Infinity-Stone is a clone of e-commerce website called CaratLane.
              which sells Ornaments across the globe. This is an group
              project developed in the time span of 6 days.
          </Box>
          <Flex className="project_links_small" id="project_links_small">
            <Box className="project-github-link" id="project_link_small">
              <a
                href="https://github.com/VivekTomar03/mysterious-cause-3185"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <AiFillGithub />
              </a>
            </Box>
            <Box className="project-deployed-link" id="project_link_small">
              <a
                href="https://infinity-stone.vercel.app/"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <span class="material-symbols-outlined">open_in_new</span>
              </a>
            </Box>
          </Flex>
        </Box>

        {/* BestReads */}
        <Box className="project-card" id="Projects_small">
          <Image
            borderRadius={"5px"}
            src="https://64.media.tumblr.com/d82dfa492a0b14ca2abed06ca2f97911/a7cc72e8e182cc99-b7/s540x810/152d0ff559cc2f84b4f88dc8ddd9df8c7f25e897.pnj"
          />
          <Box className="project-title" id="project_title_small" >G'K Taste</Box>
          <Box className="project-tech-stack" id="project_tectstack_small" >HTML | CSS | React | Redux | Chakra UI</Box>
          <Box className="project-description" id="project_description_small" >
          GK Taste is an Food related website ,where Different Kind of Foods,
             are available like Veg,and Non veg with Varities.
             User can simply order the food and the food will be Delivered.
          </Box>
          <Flex className="project_links_small" id="project_links_small">
            <Box className="project-github-link" id="project_link_small">
              <a
                href="https://github.com/SG-Kolipyaka/adroit-desire-6989"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <AiFillGithub />
              </a>
            </Box>
            <Box className="project-deployed-link" id="project_links_small">
              <a
                href="https://gktaste.netlify.app/"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <span class="material-symbols-outlined">open_in_new</span>
              </a>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default Projects;